import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class UserPath extends BaseRouteConfig {
  public readonly Index = 'user';

  public readonly Account = new ACDLRoute<{ workspaceId: string }>(`${this.Path}/account`);
  public readonly CloudCosts = {
    Path: `${this.Path}/cloud-costs`,
    Paths: new ACDLRoute<{ workspaceId: string; tab: string }>(`${this.Path}/cloud-costs/:tab`),
    History: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/cloud-costs/history`),
  };
}
